import React__default from 'react';
import { NvSpinner } from '@invitae/ids-react';
import styles from './LoadingOverlay.module.esm.js';

var LoadingOverlay = function () { return (React__default.createElement("div", { className: styles.root, "data-testid": "loading-overlay" },
    React__default.createElement(NvSpinner, { isLoading: true }))); };

export { LoadingOverlay as default };
//# sourceMappingURL=LoadingOverlay.esm.js.map
